import Icon from '../components/Icon.vue'

Icon.register({
  award: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M97.1 362.6c13.8 13.8 32.1 21.4 51.6 21.4 12.4 0 24.5-3.5 35.3-9.6l-52 127.6c-4.4 10.8-18.4 13.4-26.4 5l-36.2-38.3-52.7 2c-11.6 0.4-19.8-11.3-15.4-22l45.4-111.2c7.6 5.9 15.9 10.8 25.4 13.3 21 5.6 16.4 3.2 25.1 11.8zM382.8 448.7c4.4 10.8-3.8 22.5-15.4 22l-52.7-2-36.3 38.3c-8 8.4-22 5.8-26.4-5l-52-127.6c10.8 6 22.9 9.6 35.3 9.6 19.5 0 37.8-7.6 51.6-21.4 8.7-8.7 4-6.2 25.1-11.8 9.5-2.5 17.9-7.4 25.4-13.3zM263 340c-13.2 13.5-33.8 15.9-49.7 5.8-5.4-3.4-14.9-6.2-21.3-6.2-6.4 0-15.9 2.8-21.3 6.2-15.9 10.1-36.5 7.6-49.7-5.8-14.7-15-16.4-14-38.8-20.1-13.9-3.8-24.8-14.8-28.5-29-7.5-28.4-5.5-25-26-45.8-10.2-10.4-14.1-25.5-10.4-39.6 7.5-28.4 7.5-24.5 0-52.8-3.7-14.1 0.3-29.2 10.4-39.6 20.4-20.8 18.5-17.4 26-45.8 3.7-14.1 14.6-25.2 28.5-29 27.9-7.6 24.5-5.6 44.9-26.4 10.2-10.4 25-14.4 38.9-10.6 27.9 7.6 24 7.6 51.9 0 13.9-3.8 28.7 0.3 38.9 10.6 20.4 20.8 17.1 18.8 45 26.4 13.9 3.8 24.8 14.8 28.5 29 7.5 28.4 5.5 25 26 45.8 10.2 10.4 14.1 25.4 10.4 39.6-7.5 28.4-7.5 24.5 0 52.8 3.7 14.1-0.3 29.2-10.4 39.6-20.4 20.8-18.5 17.4-26 45.8-3.7 14.1-14.6 25.2-28.5 29-21.8 5.9-23.5 4.6-38.8 20.1zM97.7 176c0 53 42.2 96 94.3 96s94.3-43 94.3-96-42.2-96-94.3-96-94.3 43-94.3 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/award.js
// module id = 636
// module chunks = 0